var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 68,
    viewBox: "0 0 64 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6555_8059)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6555_8059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 74
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.893509H64V73.3672H0V0.893509Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6555_8059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.0416 13.6599C52.8497 14.4663 50.4495 14.9121 47.9324 14.9121C41.2056 14.9121 35.3094 7.87892 32.0142 3.11189H31.9864C28.6912 7.87892 22.795 14.9121 16.0681 14.9121C13.5511 14.9121 11.1509 14.4663 8.95898 13.6599V30.7379C8.95898 44.3809 16.808 57.0638 29.7342 64.3081C31.1201 65.0848 32.8804 65.0848 34.2664 64.3081C47.1926 57.0638 55.0416 44.3809 55.0416 30.7379V13.6599Z",
    stroke: "#01A5AF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5847 31.901H35.8596V25.1316H28.1431V31.901H21.418V39.6681H28.1431V46.4375H35.8596V39.6681H42.5847V31.901Z",
    stroke: "#01A5AF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6555_8059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 68,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.7be437a77587a52c6a5bc7921ada9b44.svg";
export { ForwardRef as ReactComponent };